import React, { useState } from "react";
import { Link } from "react-router-dom";

// utils
import { LISTING_TYPE, IPropertyNFTDescriptor } from "../../platformUtils";

// media
import verifyFilledStarIcon from "../../media/simple-mono-icons/verify-filled-star-icon.svg";

function PropertyCard(props: {
  property: IPropertyNFTDescriptor;
  size: "sm" | "md";
  private?: boolean;
}) {
  let listingTypeStr = "Unlisted";
  let listingPriceStr;
  if (props.property?.listing?.auction?.starting_price) {
    listingTypeStr = " For Auction";
    listingPriceStr = "Starting at";
  } else if (props.property?.listing?.fixed_price?.price) {
    listingTypeStr = "For Sale";
    listingPriceStr = "Price";
  } else if (props.property?.listing?.rental?.price) {
    listingTypeStr = "For Rent";
    listingPriceStr = "Price";
  } else {
    console.log("PropertyCard: unknown listing type");
    return;
  }

  return (
    <Link to={`/property/${props.property.id}/${props.private}`}>
      <div
        role="link"
        className="w-60 relative bg-white rounded-2 p-2 shadow-lg transition-all cursor-pointer hover:scale-105 hover:shadow-2xl hover:z-10"
      >
        <img
          className={`w-full rounded-2 mb-2 object-cover sm w-40 h-40`}
          src={props.property.listing.property.images.blockchain}
          alt=""
        />
        <div className="p-3">
          <div className="text-mid-grey italic text-sm mb-2 inline">
            {props.property.listing.metaverse}
            <img
              className="inline ml-1"
              src={verifyFilledStarIcon}
              alt="Verified metaverse property"
            />
          </div>
          <div className="font-bold mb-5">
            {props.property.listing.property.name}
          </div>
          <div className="text-mid-grey text-sm mb-1 font-bold">{listingTypeStr}</div>
          <div className="font-bold">
            {" "}
            <span className="text-logo-green text-md font-bold">{listingPriceStr}:{" "}</span>
            <span className="">
            {props.property?.listing?.auction?.starting_price
              ? props.property?.listing?.auction?.starting_price
              : props.property?.listing?.fixed_price?.price
              ? props.property?.listing?.fixed_price?.price
              : props.property?.listing?.rental?.price
              ? props.property?.listing?.rental?.price
              : "0.0"}
              </span>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default PropertyCard;
